/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

export default {
	hookPrefix: 'map',
	mapLanguages: [
		{ value: 'af',	label: __( 'Afrikaans', 'gutenify' ) },
		{ value: 'sq',	label: __( 'Albanian', 'gutenify' ) },
		{ value: 'am',	label: __( 'Amharic', 'gutenify' ) },
		{ value: 'ar',	label: __( 'Arabic', 'gutenify' ) },
		{ value: 'hy',	label: __( 'Armenian', 'gutenify' ) },
		{ value: 'az',	label: __( 'Azerbaijani', 'gutenify' ) },
		{ value: 'eu',	label: __( 'Basque', 'gutenify' ) },
		{ value: 'be',	label: __( 'Belarusian', 'gutenify' ) },
		{ value: 'bn',	label: __( 'Bengali', 'gutenify' ) },
		{ value: 'bs',	label: __( 'Bosnian', 'gutenify' ) },
		{ value: 'bg',	label: __( 'Bulgarian', 'gutenify' ) },
		{ value: 'my',	label: __( 'Burmese', 'gutenify' ) },
		{ value: 'ca',	label: __( 'Catalan', 'gutenify' ) },
		{ value: 'zh',	label: __( 'Chinese', 'gutenify' ) },
		{ value: 'hr',	label: __( 'Croatian', 'gutenify' ) },
		{ value: 'cs',	label: __( 'Czech', 'gutenify' ) },
		{ value: 'da',	label: __( 'Danish', 'gutenify' ) },
		{ value: 'nl',	label: __( 'Dutch', 'gutenify' ) },
		{ value: 'en',	label: __( 'English', 'gutenify' ) },
		{ value: 'et',	label: __( 'Estonian', 'gutenify' ) },
		{ value: 'fa',	label: __( 'Farsi', 'gutenify' ) },
		{ value: 'fi',	label: __( 'Finnish', 'gutenify' ) },
		{ value: 'fr',	label: __( 'French', 'gutenify' ) },
		{ value: 'gl',	label: __( 'Galician', 'gutenify' ) },
		{ value: 'ka',	label: __( 'Georgian', 'gutenify' ) },
		{ value: 'de',	label: __( 'German', 'gutenify' ) },
		{ value: 'el',	label: __( 'Greek', 'gutenify' ) },
		{ value: 'gu',	label: __( 'Gujarati', 'gutenify' ) },
		{ value: 'iw',	label: __( 'Hebrew', 'gutenify' ) },
		{ value: 'hi',	label: __( 'Hindi', 'gutenify' ) },
		{ value: 'hu',	label: __( 'Hungarian', 'gutenify' ) },
		{ value: 'is',	label: __( 'Icelandic', 'gutenify' ) },
		{ value: 'id',	label: __( 'Indonesian', 'gutenify' ) },
		{ value: 'it',	label: __( 'Italian', 'gutenify' ) },
		{ value: 'ja',	label: __( 'Japanese', 'gutenify' ) },
		{ value: 'kn',	label: __( 'Kannada', 'gutenify' ) },
		{ value: 'kk',	label: __( 'Kazakh', 'gutenify' ) },
		{ value: 'km',	label: __( 'Khmer', 'gutenify' ) },
		{ value: 'ko',	label: __( 'Korean', 'gutenify' ) },
		{ value: 'ky',	label: __( 'Kyrgyz', 'gutenify' ) },
		{ value: 'lo',	label: __( 'Lao', 'gutenify' ) },
		{ value: 'lv',	label: __( 'Latvian', 'gutenify' ) },
		{ value: 'lt',	label: __( 'Lithuanian', 'gutenify' ) },
		{ value: 'mk',	label: __( 'Macedonian', 'gutenify' ) },
		{ value: 'ms',	label: __( 'Malay', 'gutenify' ) },
		{ value: 'ml',	label: __( 'Malayalam', 'gutenify' ) },
		{ value: 'mr',	label: __( 'Marathi', 'gutenify' ) },
		{ value: 'mn',	label: __( 'Mongolian', 'gutenify' ) },
		{ value: 'ne',	label: __( 'Nepali', 'gutenify' ) },
		{ value: 'no',	label: __( 'Norwegian', 'gutenify' ) },
		{ value: 'pl',	label: __( 'Polish', 'gutenify' ) },
		{ value: 'pt',	label: __( 'Portuguese', 'gutenify' ) },
		{ value: 'pa',	label: __( 'Punjabi', 'gutenify' ) },
		{ value: 'ro',	label: __( 'Romanian', 'gutenify' ) },
		{ value: 'ru',	label: __( 'Russian', 'gutenify' ) },
		{ value: 'sr',	label: __( 'Serbian', 'gutenify' ) },
		{ value: 'si',	label: __( 'Sinhalese', 'gutenify' ) },
		{ value: 'sk',	label: __( 'Slovak', 'gutenify' ) },
		{ value: 'sl',	label: __( 'Slovenian', 'gutenify' ) },
		{ value: 'es',	label: __( 'Spanish', 'gutenify' ) },
		{ value: 'sw',	label: __( 'Swahili', 'gutenify' ) },
		{ value: 'sv',	label: __( 'Swedish', 'gutenify' ) },
		{ value: 'ta',	label: __( 'Tamil', 'gutenify' ) },
		{ value: 'te',	label: __( 'Telugu', 'gutenify' ) },
		{ value: 'th',	label: __( 'Thai', 'gutenify' ) },
		{ value: 'tr',	label: __( 'Turkish', 'gutenify' ) },
		{ value: 'uk',	label: __( 'Ukrainian', 'gutenify' ) },
		{ value: 'ur',	label: __( 'Urdu', 'gutenify' ) },
		{ value: 'uz',	label: __( 'Uzbek', 'gutenify' ) },
		{ value: 'vi',	label: __( 'Vietnamese', 'gutenify' ) },
		{ value: 'zu',	label: __( 'Zulu', 'gutenify' ) },
	],
};
